const NS = 'WoolLabSaveToMoodboardModalBlock';
const CLS = 'woolLabSaveToMoodboardModalBlock';

export class WoolLabSaveToMoodboardModalBlock {
	constructor(el, data) {
		this.$el = $(el);
		this.getMoodboardsApi = data.getMoodboardsApi;
		this.addToMoodboardApi = data.addToMoodboardApi;
		this.createMoodboardApi = data.createMoodboardApi;
		this.selectedItems = data.selectedItems;
		this.itemType = data.itemType;

		this.$moodboardSearchInput = this.$el.find(`.${CLS}-saveToMoodboards-searchInput`);
		this.$moodboardsContainer = this.$el.find(`.${CLS}-moodboards`);
		this.$moodboardContainer = this.$el.find(`.${CLS}-moodboard`);
		this.$saveToMoodboardsDiv = this.$el.find(`.${CLS}-saveToMoodboards`);
		this.$btnNewMoodboard = this.$el.find(`.${CLS}-newMoodboardBtn`);
		this.$btnDone = this.$el.find(`.${CLS}-doneBtn`);
		this.selectedMoodboardId = '';

		this.newMoodboardText = '';
		this.$newMoodboardDiv = this.$el.find(`.${CLS}-newMoodboard`);
		this.$newMoodboardCreateBtn = this.$el.find(`.${CLS}-createBtn`);
		this.$newMoodboardInput = this.$el.find(`.${CLS}-newMoodboard-textInput`);

		this.$btnNewMoodboard.on('click', () => {
			this.showNewMoodboardPanel();
		});

		this.$newMoodboardCreateBtn.on('click', () => {
			if (this.newMoodboardText !== '') {
				this.createMoodboard();
			}
		});

		this.$btnDone.on('click', () => {
			if (this.selectedMoodboardId !== '') {
				this.addSwatchToMoodboard();
				this.$el.modal('hide');
				this.$el.trigger('resetSavePanel');
			}
		});

		this.handleSearchInput();
		this.handleNewMoodboardInput();

		this.getMoodboards();
	}

	getMoodboards() {
		this.$el.addClass('loading');
		let url = `${this.getMoodboardsApi}`;

		$.ajax({
			type: 'GET',
			url: url,
			success: (data) => {
				this.$el.removeClass('loading');
				if (data.length > 0) {
					this.updateMoodboards(data);
				} else {
					this.showNewMoodboardPanel();
				}
			},
		});
	}

	handleMoodboardClicked() {
		this.$moodboards.on('click', (e) => {
			this.$moodboards.removeClass('selected');
			let $moodboard = $(e.currentTarget);
			$moodboard.addClass('selected');
			this.selectedMoodboardId = $moodboard.attr('data-id');
			this.$btnDone.removeClass('disabled');
		});
	}

	handleSearchInput() {
		this.$moodboardSearchInput.on('keyup', (event) => {
			let input = $(event.currentTarget).val().trim();
			let filter = input.toUpperCase();

			if (this.$moodboards.length > 0) {
				this.$moodboards.map((i, obj) => {
					let txtValue = $(obj).attr('data-name');
					if (txtValue.toUpperCase().indexOf(filter) > -1) {
						obj.style.display = '';
					} else {
						obj.style.display = 'none';
					}
				});
			}
		});
	}

	handleNewMoodboardInput() {
		this.$newMoodboardInput.on('keyup', (event) => {
			let input = $(event.currentTarget).val().trim();
			if (input.length > 0) {
				this.$newMoodboardCreateBtn.removeClass('disabled');
			} else {
				this.$newMoodboardCreateBtn.addClass('disabled');
			}

			this.newMoodboardText = input;
		});
	}

	showNewMoodboardPanel() {
		this.$el.addClass('showNewMoodboard');
	}

	hideNewMoodboardPanel() {
		this.$el.removeClass('showNewMoodboard');
	}

	updateMoodboards(data) {
		let moodboardHTML = '';
		data.map((i) => {
			let swatchText = i.swatchCount == 1 ? 'swatch' : 'swatches';
			let imageUrl = i.images != null || i.images.length > 0 ? i.images[0] : '';

			moodboardHTML += `<div class="${CLS}-moodboard" data-id="${i.id}" data-name="${i.name}">
								<img class="${CLS}-moodboard-image" src="${imageUrl}">
								<div class="${CLS}-moodboard-text">
									<h4 class="${CLS}-moodboard-title">${i.name}</h4>
									<p class="${CLS}-moodboard-count">${i.swatchCount} ${swatchText}</p>
								</div>
							</div>`;
		});
		this.$moodboardsContainer.empty();
		this.$moodboardsContainer.html(moodboardHTML);
		this.$moodboards = this.$el.find(`.${CLS}-moodboard`);
		this.handleMoodboardClicked();
	}

	addSwatchToMoodboard() {
		let data = JSON.stringify({
			items: this.selectedItems,
			moodboardId: this.selectedMoodboardId,
			type: this.itemType
		});

		fetch(this.addToMoodboardApi, {
			method: 'POST',
			dataType: 'json',
			body: data
		}).then((response) => {
			return response.json();
		}).then((_json) => {
		}).catch((_error) => {
		});
	}


	createMoodboard() {
		let data = JSON.stringify({
			title: this.newMoodboardText
		});

		if ($("#dulicateWarningText").length){
			$( "#dulicateWarningText" ).remove();
			this.$newMoodboardCreateBt.removeClass('disabled');
		}

		var moodboardsName = [];
		var inputMoodboardName = this.newMoodboardText.toLowerCase();
		$( ".woolLabSaveToMoodboardModalBlock-moodboard" ).each(function( index ) {
			moodboardsName.push($( this ).find(".woolLabSaveToMoodboardModalBlock-moodboard-title").text().toLowerCase());
		  });
		if(containsDuplicates(moodboardsName, inputMoodboardName)){
			if (!$("#dulicateWarningText").length){
				$( "<p id='dulicateWarningText' style='color:#FF0000'>This moodboard name already exists.</p>" ).insertAfter( this.$newMoodboardInput );
				this.$newMoodboardCreateBtn.addClass('disabled');
			}
		}
		else{
			this.$el.addClass('loading');

			fetch(this.createMoodboardApi, {
				method: 'POST',
				dataType: 'json',
				body: data
			}).then((_json) => {
				this.hideNewMoodboardPanel();
				this.getMoodboards();
			}).catch((_error) => {
			});
		}
		function containsDuplicates(nameArray, inputText) {
			for (let i = 0; i < nameArray.length; i++){
				if (nameArray[i] === inputText){
					return true;
				}
			}
			return false;
		}
	}
}

